<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { CapexAccountEditorFormSubmitEventPayload, CapexAccountEditorViewModel } from "@Quest/Financials/Capex/Components/CapexAccountEditor";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CapexAccountEditor extends Vue
    {
        get vm(): CapexAccountEditorViewModel { return this.$props.viewModel as CapexAccountEditorViewModel; }

        get opened(): boolean { return this.vm?.opened ?? false; }
        get confirmButtonLabel(): string { return this.vm.confirmButtonLabel; }
        get modalTitle(): string { return this.vm.modalTitle; }

        get name(): string | null { return this.vm.name; }
        set name(val: string | null) { this.vm.name = val; }

        get description(): string | null { return this.vm.description; }
        set description(val: string | null) { this.vm.description = val; }

        get classification(): string | null { return this.vm.classification; }
        set classification(val: string | null) { this.vm.classification = val; }

        handleFormSubmit()
        {
            const payload = new CapexAccountEditorFormSubmitEventPayload(this.vm.id, this.name, this.description, this.classification);
            this.$emit('form-submit', payload);
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalTitle }}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="capex-account-editor-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input type="text" v-model.trim="name" class="form-control" required maxlength="100" minlength="2" />
                            </div>
                            <div class="form-group">
                                <label>Description:</label>
                                <textarea v-model.trim="description" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label for="classification">Depreciation:</label>
                                <select id="classification" v-model="classification" class="form-control">
                                    <option value="OpEx">OpEx</option>
                                    <option value="COGS">COGS</option>
                                    <option value="Other">Other expenses</option>
                                </select>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="capex-account-editor-form" class="btn btn-primary">{{ confirmButtonLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 